module.exports = __webpack_public_path__ + "static/media/damaha_dee_dirgha.c7a0f695.ogg";